import createFormReducer, {getFormInitialState} from "../form/create-form-reducer";
import {Validators} from "../../../components/_common/_form/Validators";

export const FORM_REGISTRATION = 'formRegistration'

const initialState = {
    ...getFormInitialState(),
    valid: false,
}


export function validate({
                             name = '',
                             email = '',
                             phoneOne = '',
                             password = '',
                             confirmPassword = '',
                             cpfCnpj = '',
                         }) {

    const requiredMessage = 'Este campo é obrigatório.'
    const errorMessages = {}

    if (!name)
        errorMessages.name = [requiredMessage]

    if (!email)
        errorMessages.email = [requiredMessage]
    else if (!!Validators.email()(email))
        errorMessages.email = [Validators.email()(email)]

    if (!phoneOne)
        errorMessages.phoneOne = [requiredMessage]
    else if (!!Validators.phone()(phoneOne))
        errorMessages.phoneOne = [Validators.phone()(phoneOne)]

    if (!password)
        errorMessages.password = [requiredMessage]
    else if (!!Validators.minLengthValidator(6)(password))
        errorMessages.password = ['A senha deve ter no mínimo 6 caracteres.']

    if (!confirmPassword)
        errorMessages.confirmPassword = [requiredMessage]
    else if (confirmPassword !== password)
        errorMessages.confirmPassword = ['A senha informada não confere.']


    if (!cpfCnpj)
        errorMessages.cpfCnpj = [requiredMessage]
    else if (!!Validators.cpf()(cpfCnpj))
        errorMessages.cpfCnpj = [Validators.cpf()(cpfCnpj)]


    return errorMessages
}


export const formRegistrationReducer = createFormReducer(FORM_REGISTRATION, validate, initialState)


// WEBPACK FOOTER //
// ./src/redux/actions-reducers/form-registration/reducer.js